import { render, staticRenderFns } from "./all-incidents-table.vue?vue&type=template&id=244e61a1&scoped=true&"
import script from "./all-incidents-table.vue?vue&type=script&lang=js&"
export * from "./all-incidents-table.vue?vue&type=script&lang=js&"
import style0 from "./all-incidents-table.vue?vue&type=style&index=0&id=244e61a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e61a1",
  null
  
)

export default component.exports